import React from 'react';

import StarIcon from '@mui/icons-material/Star';
import { Box, Typography, styled } from '@mui/material';

import AvatarLogo from 'assets/images/relifCompanies/avatar-logo.webp';
import PLogo from 'assets/images/relifCompanies/p-logo.webp';
import SLogo from 'assets/images/relifCompanies/s-logo.webp';
import ZLogo from 'assets/images/relifCompanies/z-logo.webp';

const Card = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  width: '100%',
  maxWidth: '350px',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '4px',
    background: '#E0E0E0',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
}));

const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

const UserInfo = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

const Avatar = styled(Box)({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

const BrandIcon = styled(Box)({
  width: '28px',
  height: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  },
});

const StarsContainer = styled(Box)({
  display: 'flex',
  gap: '2px',
  marginTop: '4px',
});

const ContentContainer = styled(Box)({
  marginTop: '16px',
  textAlign: 'justify',
});

export interface PersonCardProps {
  name: string;
  comment: string;
  rating: number;
  brandName: string;
}

export const PersonCard = ({ name, comment, rating, brandName }: PersonCardProps) => {
  const renderStars = () => {
    return Array.from({ length: rating }, (_, i) => (
      <StarIcon key={`star-${name}-${i}`} sx={{ color: '#FFD700', fontSize: '16px' }} />
    ));
  };
  const brandLogoMap = {
    Planer: PLogo,
    Siker: SLogo,
    Zeller: ZLogo,
  };
  const brandLogo = brandLogoMap[brandName as keyof typeof brandLogoMap];

  return (
    <Card>
      <Header>
        <UserInfo>
          <Avatar>
            <img src={AvatarLogo} alt={name} />
          </Avatar>
          <Box>
            <Typography variant="subtitle1" fontWeight="500">
              {name}
            </Typography>
            <StarsContainer>{renderStars()}</StarsContainer>
          </Box>
        </UserInfo>
        <BrandIcon>
          <img src={brandLogo} alt={brandName} />
        </BrandIcon>
      </Header>
      <ContentContainer>
        <Typography variant="body2" color="text.secondary">
          {comment}
        </Typography>
      </ContentContainer>
    </Card>
  );
};

export default PersonCard;
